import React from 'react';
import RadioGroup from '@nib-components/radio-group';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
const LABELS = {
  ARHI: DEFAULT_LABELS.PAYMENT_METHOD
};
const PaymentMethod = props => {
  const {
    funnel = FUNNELS.ARHI,
    help = '',
    width = 20,
    optional = false,
    options = {
      DirectDebit: 'Direct debit',
      CreditCard: 'Credit card'
    }
  } = props;
  return React.createElement(BaseFormField, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    funnel: funnel,
    width: width,
    help: help,
    optional: optional
  }, React.createElement(RadioGroup, {
    options: options
  }));
};
PaymentMethod.defaultProps = {
  ...defaultFieldPropTypes,
  options: {
    DirectDebit: 'Direct debit',
    CreditCard: 'Credit card'
  }
};
const PaymentMethodWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(PaymentMethod, {
  ...props
}));
export default PaymentMethodWithFunnel;